// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'

import {
  TabbedView,
  SvgIcon,
  EmployerGroupCommunications,
  EmployerBulkSMSAudiences,
  EmployerGroupBulkSMSMessageList,
  EmployerGroupBulkSMSMessageCompose
} from '../../components'


const getFiltersFromQueryString = (queryString) => {
  let queryParams = qs.parse(queryString)

  let filters = Object.assign(
    {},
    ...Object.keys(queryParams).map(key => (
      key === 'tab'
        ? { currentTab: parseInt(queryParams[key], 10) }
        : null
    ))
  )
  return filters
}


class EmployerGroupSMS extends Component {
  static propTypes = {
    fromAddr: PropTypes.string,
    toAddr: PropTypes.string,
    title: PropTypes.string,
    noStatusFilter: PropTypes.bool
  }

  static defaultProps = {
    title: <div className='slds-grid' style={{ alignItems: 'center' }}>
        <SvgIcon
          variant='utility'
          symbol='comments'
          colour='light'
          size='large'
        />
        <div className='slds-m-left_medium u-font-size-x-large u-text-caps'>
          SMS
        </div>
      </div>
  }

  state = {
    currentTab: 0
  }

  componentDidMount() {
    if (this.props.location.search.length === 0) {
      this.setQueryString()
    } else {
      this.setState(getFiltersFromQueryString(this.props.location.search))
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState(getFiltersFromQueryString(this.props.location.search))
    }
  }

  setQueryString = () => {
    this.props.history.push({
      search: qs.stringify({
        tab: this.state.currentTab
      })
    })
  }

  changeViewAndSearchParams = (tabIndex) => {
    this.props.history.replace({ search: '' })  // clear query string search params

    this.setState({
      currentTab: tabIndex  // change to chosen tab
    }, this.setQueryString)
  }

  displayAssociatedContent = (currentTab) => {
    const MESSAGES = 0
    const BULK_MESSAGES = 1
    const BULK_COMPOSE = 2
    const AUDIENCES = 3

    const employerGroupId = this.props.match.params.employerGroupId
    const currentPath = this.props.location.pathname

    if (currentTab === MESSAGES) {
      return (
        <EmployerGroupCommunications
          employerGroupId={employerGroupId}
          communicationType='SMS'
          urlPath={currentPath}
          title={null}
          lockOnCommunicationType={true}
        />
      )
    }

    if (currentTab === BULK_MESSAGES) {
      return (
        <EmployerGroupBulkSMSMessageList
          employerGroupId={employerGroupId}
        />
      )
    }

    if (currentTab === BULK_COMPOSE) {
      return (
        <EmployerGroupBulkSMSMessageCompose
          employerGroupId={employerGroupId}
          goToBulkMessageDetailPage={messageId => this.props.history.push(`/group/${employerGroupId}/communications/bulk/${messageId}`)}
          goToAudienceListingPage={() => this.props.history.push(`/group/${employerGroupId}/communications?tab=3`)}
        />
      )
    }

    if (currentTab === AUDIENCES) {
      return (
        <EmployerBulkSMSAudiences
          employerGroupId={employerGroupId}
          goToAudienceDetailPage={audienceId => this.props.history.push(`/group/${employerGroupId}/communications/bulk/audience/${audienceId}`)}
        />
      )
    }
  }

  render() {
    const tabs = ['Messages', 'Bulk messages', 'Compose bulk message', 'Audiences']

    return (
      <div className='slds-grow slds-scrollable_y' role="main">
        <div className='slds-grid slds-wrap slds-size_1-of-1'>
          <div className='tab-nav slds-size_1-of-1 u-bg-color-white product-listing-page-header'>
            {this.props.title !== null &&
              <div className='slds-m-top_x-small slds-m-bottom_xxx-small slds-p-left_large product-listing-page-header_title'>
                {this.props.title}
              </div>
            }
            {this.props.noStatusFilter
              ? null
              : <TabbedView
                  tabs={tabs}
                  contents={[]}
                  selectedTab={this.state.currentTab}
                  onClick={this.changeViewAndSearchParams}
                  tabsClassName='slds-align_absolute-center product-listing-page-header_tabs'
                />
            }
          </div>
          {this.displayAssociatedContent(this.state.currentTab)}
        </div>
      </div>
    )
  }
}

export default withRouter(EmployerGroupSMS)



// WEBPACK FOOTER //
// ./src/containers/messageplus/EmployerGroupSMS.js